import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setCookie } from '../../utils/cookieUtils';
import { FEDERATE_ID_TOKEN } from '../../shared/config/authConfig';
import { consumeFederateCallback } from '../../shared/auth/federateAuth';
import Spinner from '@amzn/awsui-components-console/spinner';

const CallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // Validates state (anti-CSRF) and the token nonce (anti-replay) before use.
      const { token, returnPath } = consumeFederateCallback();
      setCookie(FEDERATE_ID_TOKEN, token, {
        path: '/',
        expires: 3600,
        secure: true,
        sameSite: 'None',
      });
      navigate(returnPath, { replace: true });
    } catch (error) {
      // Reject without persisting anything; send back to a clean login.
      console.error('Federate callback rejected:', error);
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spinner size="large" />
    </div>
  );
};

export default CallbackPage;
